import { Box, Button, Flex, Icon, Text, Checkbox, HStack, VStack } from '@chakra-ui/react'
import { FiSearch } from 'react-icons/fi'
import { useFormContext } from 'react-hook-form'
import { statusArray } from '../utils/statusConfig'
import { CustomInputOmni } from '../../../../components/CustomInputOmni'
import { CustomSelectOmni } from '../../../../components/CustomSelectOmni'

export function FilterForm({ onSubmit, isSubmitting }) {
  const { register, handleSubmit } = useFormContext()

  return (
    <Box as="form" onSubmit={handleSubmit(onSubmit)} mb={4} p={4} borderRadius="8px" bg="#F9F9F9">
      {/* Linha superior de filtros */}
      <Flex flexWrap={{ base: 'wrap', md: 'nowrap' }} gap={4} mb={4} alignItems="flex-end">
        <Box>
          <CustomInputOmni label="Número" placeholder="Número pedido" {...register('numeroPedido')} maxW="210px" />
        </Box>

        {/* Campo De: */}
        <Box>
          <CustomInputOmni label="De" placeholder="dd/mm/aaaa" type="date" {...register('dataInicio')} maxW="210px" />
        </Box>

        {/* Campo Até: */}
        <Box>
          <CustomInputOmni label="Até" placeholder="dd/mm/aaaa" type="date" {...register('dataFim')} maxW="210px" />
        </Box>

        {/* Campo Status Atual */}
        <Box>
          <CustomSelectOmni label="Passo atual" placeholder="Passo atual" {...register('passoAtual')} maxW="210px">
            {statusArray.map((status) => (
              <option key={status} value={status}>
                {status}
              </option>
            ))}
          </CustomSelectOmni>
        </Box>

        {/* Campo Próxima Etapa */}
        <Box>
          <CustomSelectOmni label="Próximo passo" placeholder="Próximo passo" {...register('proximoPasso')} maxW="210px">
            {statusArray.map((status) => (
              <option key={status} value={status}>
                {status}
              </option>
            ))}
          </CustomSelectOmni>
        </Box>

        {/* Botão Buscar */}
        <Button
          type="submit"
          leftIcon={<Icon as={FiSearch} />}
          colorScheme="blue"
          bg="#378BBF"
          fontSize="12px"
          px={6}
          py={2}
          h="40px"
          borderRadius="8px"
          isLoading={isSubmitting}
          loadingText="Buscando..."
        >
          Buscar
        </Button>
      </Flex>

      {/* Checkboxes de tipos de gravação */}
      <HStack spacing={6} mt={4} mb={2} flexWrap="wrap" justifyContent="center">
        <Checkbox colorScheme="blue" size="md" {...register('tiposGravacao.laser')}>
          <Text fontSize="12px" color="#313E44">
            Laser
          </Text>
        </Checkbox>

        <Checkbox colorScheme="blue" size="md" {...register('tiposGravacao.serigrafia')}>
          <Text fontSize="12px" color="#313E44">
            Serigrafia
          </Text>
        </Checkbox>

        <Checkbox colorScheme="blue" size="md" {...register('tiposGravacao.tampografia')}>
          <Text fontSize="12px" color="#313E44">
            Tampografia
          </Text>
        </Checkbox>

        <Checkbox colorScheme="blue" size="md" {...register('tiposGravacao.uv')}>
          <Text fontSize="12px" color="#313E44">
            UV
          </Text>
        </Checkbox>

        <Checkbox colorScheme="blue" size="md" {...register('tiposGravacao.silk')}>
          <Text fontSize="12px" color="#313E44">
            Silk
          </Text>
        </Checkbox>

        <Checkbox colorScheme="blue" size="md" {...register('tiposGravacao.etiqueta')}>
          <Text fontSize="12px" color="#313E44">
            Etiqueta
          </Text>
        </Checkbox>

        <Checkbox colorScheme="blue" size="md" {...register('tiposGravacao.placa')}>
          <Text fontSize="12px" color="#313E44">
            Placa
          </Text>
        </Checkbox>

        <Checkbox colorScheme="blue" size="md" {...register('tiposGravacao.dtf')}>
          <Text fontSize="12px" color="#313E44">
            DTF
          </Text>
        </Checkbox>

        <Checkbox colorScheme="blue" size="md" {...register('tiposGravacao.colorida')}>
          <Text fontSize="12px" color="#313E44">
            Colorida
          </Text>
        </Checkbox>
      </HStack>
    </Box>
  )
}
